export default __webpack_public_path__ + "static/media/Dashboard-bg.2804a9a6.png";